import { Preferences } from '@capacitor/preferences'
import { OFFLINE_QUEUE_SNAPSHOT_KEY } from './offlineQueue'

export async function clearOfflineQueueSnapshot (): Promise<void> {
  try {
    await Preferences.remove({ key: OFFLINE_QUEUE_SNAPSHOT_KEY })
  } catch {
    /* Preferences is native-only; ignore on web and in unit tests. */
  }
}
